import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth, functions } from '../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import { httpsCallable } from 'firebase/functions';

export function useLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoggingIn, setIsLoggingIn] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (event) => {
    event.preventDefault();
    setError('');
    setIsLoggingIn(true);

    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      if (user) {
        const idTokenResult = await user.getIdTokenResult();
        const claims = idTokenResult.claims;
        const claimsAreMissing = !claims.orgId || !claims.userMid || !claims.userFid;

        if (claimsAreMissing) {
          setError('Finalizing account setup...');
          try {
            const addClaimCredsFn = httpsCallable(functions, 'addClaimCreds');
            await addClaimCredsFn();
            await user.getIdToken(true);
            setError('');
          } catch (claimError) {
            console.error('Error calling addClaimCreds:', claimError);
            setError('Login successful, but an issue occurred updating account details.');
          }
        }
      }
      navigate('/dashboard');
    } catch (err) {
      console.error("Login Error:", err);
      if (err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password' || err.code === 'auth/invalid-credential') {
        setError('Invalid email or password.');
      } else if (err.code === 'auth/invalid-email') {
        setError('Please enter a valid email address.');
      } else {
        setError('Failed to log in. Please try again.');
      }
    } finally {
      setIsLoggingIn(false);
    }
  };

  return { email, setEmail, password, setPassword, error, isLoggingIn, handleLogin };
}
